import React from "react";

const Card = ({ children }) => (
  <div className="bg-white shadow-md rounded-lg p-4">{children}</div>
);

const CardContent = ({ children }) => <div>{children}</div>;

export { Card, CardContent };
